// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"3aaa86a1","53":"be025ed2","220":"3d31b561","265":"05b6c8b0","339":"577b0055","363":"824c92a7","364":"e7ff1245","627":"da05f5bc","644":"8c9b0e03","950":"039cbca2"}[chunkId] + ".chunk.js";
};